import React, { useEffect, useState } from 'react'
import {
	FixBtns,
	LectureListSearch,
	LectureView,
	LectureViewHeader,
	LectureViewTable,
	LectureWrapper,
	StudentViewTable,
} from '../Lecture/styles'
import StudentList from './StudentList'
import StudentTotalTable from './StudentTotalTable'
import AddStudentModal from 'app/gomsacademy/components/AddStudentModal'
import { Icon, IsAdd, IsAddBtn } from '../Home/styles'
import { FaCheck } from 'react-icons/fa6'
import { BsFillPencilFill } from 'react-icons/bs'
import { useGetUser } from 'app/gomsacademy/hooks/GetUser'
import { useGetUserClass } from 'app/gomsacademy/hooks/GetClassList'
import API from 'utils/api'
import { useToken } from 'app/hooks'
import { Input, Select, message } from 'antd'
import { useTeacherStudent } from 'app/gomsacademy/hooks/TeacherStudentList'
import { convertBinaryToDays } from 'utils/ciutils'
import { useLocation } from 'react-router-dom'
import { useLectureList } from 'app/gomsacademy/hooks/LectureList'
import { FaPlus } from 'react-icons/fa6'
import { CiSearch } from 'react-icons/ci'
import TextArea from 'antd/es/input/TextArea'

const DAY_OPTIONS = ['월', '화', '수', '목', '금', '토', '일'] as const

function daysBinaryToArray(binary?: string): string[] {
	if (!binary || typeof binary !== 'string') return []
	const bits = binary.split('')
	return DAY_OPTIONS.filter((_, idx) => bits[idx] === '1')
}

function daysArrayToBinary(days: string[]): string {
	const set = new Set(days)
	return DAY_OPTIONS.map(d => (set.has(d) ? '1' : '0')).join('')
}

function canonicalizeGrade(schoolType: string, grade: number | null): number | null {
	if (grade === null || grade === undefined) return null
	if (Number(grade) === 0) return 0
	if (schoolType === '중' && grade >= 1 && grade <= 3) return grade + 6
	if (schoolType === '고' && grade >= 1 && grade <= 3) return grade + 9
	return grade
}

function toGradeInSchool(schoolType: string, grade: number | null | undefined): number | null {
	if (grade === null || grade === undefined) return null
	if (Number(grade) === 0) return 0
	if (schoolType === '중' && grade >= 7 && grade <= 9) return grade - 6
	if (schoolType === '고' && grade >= 10 && grade <= 12) return grade - 9
	return grade
}

function clampGradeForSchoolType(schoolType: string, grade: number | null): number | null {
	if (grade === null || grade === undefined) return null
	if (Number(grade) === 0) return 0
	if (schoolType === '초') return grade >= 1 && grade <= 6 ? grade : 1
	if (schoolType === '중' || schoolType === '고') return grade >= 1 && grade <= 3 ? grade : 1
	return grade >= 1 && grade <= 12 ? grade : 1
}

export const Student = ({
	setSelectLecture,
	isWrite,
	setManageSt,
	setManageUserLectureModal,
	setSelectStudentNote,
	setEditNoteIndex,
	selectLecture
}) => {
	const location = useLocation()
	const params = new URLSearchParams(location.search)
	const id = params.get('id')

	const { data: token } = useToken()
	const { mutate: StudentAllMutate } = useTeacherStudent(3)
	// userId 받아오기
	const [selectStudent, setSelectStudent] = useState('')
	const { UserData, mutate: StudentMutate } = useGetUser(selectStudent)
	const { UserClassData, mutate: userClassMutate } = useGetUserClass(selectStudent)
	const { LectureListData } = useLectureList(0)

	const [isTotal, setIsTotal] = useState(true)
	const [isAddStudent, setIsAddStudent] = useState(false)
	const [isFix, setIsFix] = useState(false)
	const [isAdd, setIsAdd] = useState(false)
	const [searchKeyword, setSearchKeyword] = useState('')
	const [AddLecture, setAddLecture] = useState(0)
	const [selectedGrade, setSelectedGrade] = useState('전체')
	const [studentSort, setStudentSort] = useState<'registered' | 'name' | 'grade'>('registered')

	const [fixName, setFixName] = useState(UserData?.name || '')
	const [fixSchoolType, setFixSchoolType] = useState(UserData?.schoolType || '')
	const [fixSchool, setFixSchool] = useState(UserData?.school || '')
	const [fixGrade, setFixGrade] = useState<number | null>(toGradeInSchool(UserData?.schoolType || '', UserData?.grade ?? null))
	const [fixPhone, setFixPhone] = useState(UserData?.phone || '')
	const [fixPhone2, setFixPhone2] = useState(UserData?.phone2 || '')
	const [fixCreatedAt, setFixCreatedAt] = useState(UserData?.createdAt || '')
	const [fixSelectedDays, setFixSelectedDays] = useState<string[]>(daysBinaryToArray(UserData?.days))
	const [fixStatus, setFixStatus] = useState(UserData?.status || '1')
	const [fixMemo, setFixMemo] = useState(UserData?.memo || '')

	// Keep editable fields in sync when switching students / when data loads.
	useEffect(() => {
		if (!UserData) return
		setFixName(UserData?.name || '')
		setFixSchoolType(UserData?.schoolType || '')
		setFixSchool(UserData?.school || '')
		setFixGrade(toGradeInSchool(UserData?.schoolType || '', UserData?.grade ?? null))
		setFixPhone(UserData?.phone || '')
		setFixPhone2(UserData?.phone2 || '')
		setFixCreatedAt(UserData?.createdAt || '')
		setFixSelectedDays(daysBinaryToArray(UserData?.days))
		setFixStatus(UserData?.status || '1')
		setFixMemo(UserData?.memo || '')
	}, [UserData?.id])

	useEffect(() => {
		if (id) {
			setSelectStudent(id)
			setIsTotal(false)
		}
	}, [id])

	const DeleteStudent = (userId, userName) => {
		const shouldDelete = window.confirm(`정말로 '${userName}' 학생을 삭제하시겠습니까?`)

		if (shouldDelete) {
			API.delete('/users/' + userId, token + '', {})
				.then((res: any) => {
					if (res.result.success) {
						StudentAllMutate()
						message.success('삭제되었습니다')
						setIsTotal(true)
					} else {
						if (res?.result?.message?.includes('foreign key')) {
							message.error('연결된 데이터가 있어 삭제할 수 없습니다.')
						} else {
							message.error(res?.result?.message || '삭제에 실패했습니다.')
						}
					}
				})
				.catch((err: any) => { })
		}
	}
	const SaveStudent = userId => {
		// Only send changed keys to avoid overwriting existing data with empty defaults.
		const datas: any = {}
		if (!UserData) return

		if ((UserData?.name || '') !== fixName) datas.name = fixName
		if ((UserData?.phone || '') !== fixPhone) datas.phone = fixPhone
		if ((UserData?.createdAt || '') !== fixCreatedAt) datas.createdAt = fixCreatedAt
		if ((UserData?.school || '') !== fixSchool) datas.school = fixSchool
		if ((UserData?.schoolType || '') !== fixSchoolType) datas.schoolType = fixSchoolType

		const nextCanonicalGrade = canonicalizeGrade(fixSchoolType || '', fixGrade)
		if ((UserData?.grade ?? null) !== nextCanonicalGrade) {
			datas.grade = fixGrade
			// backend validation requires schoolType when grade is non-null and non-zero
			if (fixGrade !== null && Number(fixGrade) !== 0) {
				datas.schoolType = fixSchoolType
			}
		}

		if ((UserData?.phone2 || '') !== fixPhone2) datas.phone2 = fixPhone2
		if ((UserData?.status || '1') !== fixStatus) datas.status = fixStatus
		if ((UserData?.memo || '') !== fixMemo) datas.memo = fixMemo

		const nextDaysBinary = daysArrayToBinary(fixSelectedDays)
		if ((UserData?.days || '') !== nextDaysBinary) datas.days = nextDaysBinary

		if (Object.keys(datas).length < 1) {
			message.info('수정사항이 없습니다')
			setIsFix(false)
			return
		}

		API.put('/users/' + userId, token + '', {
			datas,
		})
			.then((res: any) => {
				if (res.result.success) {
					StudentMutate()
					message.success('수정되었습니다')
					setIsFix(false)
				}
			})
			.catch((err: any) => { })
	}

	// ** 강의 추가 input 검색
	const searchAddLecture = () => {
		return LectureListData.filter(lecture =>
			lecture.name.toLowerCase().includes(searchKeyword.toLowerCase())
		)
	}
	// ** 선택한 강의를 학생에 등록 =====
	const clickAddStudent = () => {
		API.post('/lecture/' + AddLecture + '/student', token + '', {
			studentIds: [selectStudent],
		})
			.then((res: any) => {
				if (res.result.success) {
					message.success('강의가 추가되었습니다')
					setSearchKeyword('')
					userClassMutate()
					setIsAdd(false)
				}
			})
			.catch((err: any) => { })
	}

	// ** 수정 누르고 다른 곳 클릭하면 닫힘
	const handleClickOutsideSelect = event => {
		if (!event.target.closest('.selectStudent')) {
			setIsFix(false)
		}
	}

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutsideSelect)
		return () => {
			document.removeEventListener('mousedown', handleClickOutsideSelect)
		}
	}, [])

	return (
		<LectureWrapper>
			<StudentList
				setIsAddStudent={setIsAddStudent}
				setIsTotal={setIsTotal}
				selectStudent={selectStudent}
				setSelectStudent={setSelectStudent}
				selectedGrade={selectedGrade}
				setSelectedGrade={setSelectedGrade}
				setSelectStudentNote={setSelectStudentNote}
				studentSort={studentSort}
			/>
			<LectureView>
				{isTotal && (
					<StudentTotalTable
						selectLecture={selectLecture}
						setIsTotal={setIsTotal}
						setSelectStudent={setSelectStudent}
						selectedGrade={selectedGrade}
						setSelectStudentNote={setSelectStudentNote}
						setManageSt={setManageUserLectureModal}
						setEditNoteIndex={setEditNoteIndex}
						setSelectLecture={setSelectLecture}
						studentSort={studentSort}
						setStudentSort={setStudentSort}
					/>
				)}
				{isTotal == false && UserData && (
					<div className="selectStudent" style={{ position: 'relative' }}>
						<LectureViewHeader>
							<p>
								{!isFix ? (
									UserData?.name
								) : (
									<Input
										className="fixName"
										type="text"
										placeholder={UserData?.name}
										onChange={e => setFixName(e.target.value)}
									/>
								)}
							</p>
							<FixBtns>
								{!isFix ? (
									<>
										<button className="fix" onClick={() => setIsFix(true)}>
											수정
										</button>
										<button
											className="delete"
											onClick={() => DeleteStudent(UserData?.id, UserData?.name)}>
											삭제
										</button>
									</>
								) : (
									<>
										<button className="fix" onClick={() => SaveStudent(UserData?.id)}>
											저장
										</button>
										<button className="delete" onClick={() => setIsFix(false)}>
											취소
										</button>
									</>
								)}
							</FixBtns>
						</LectureViewHeader>
						<StudentViewTable>
							<thead>
								<tr>
									<th>학교</th>
									<th>학교명</th>
									<th>학년</th>
									<th>학생번호</th>
									<th>학부모번호</th>
									<th>등록일</th>
									<th>등원요일</th>
									<th>재원여부</th>
								</tr>
							</thead>
							<tbody className="studentTbody">
								<tr>
									<td>
										{!isFix ? (
											UserData?.schoolType == '' ? (
												'-'
											) : (
												UserData?.schoolType
											)
										) : (
											<select
												value={fixSchoolType}
												onChange={e => {
													const next = e.target.value
													setFixSchoolType(next)
													setFixGrade(prev => clampGradeForSchoolType(next, prev))
												}}>
												<option value="">N수</option>
												<option value="고">고</option>
												<option value="중">중</option>
												<option value="초">초</option>
											</select>
										)}
									</td>
									<td>
										{!isFix ? (
											UserData?.school == '' ? (
												'-'
											) : (
												UserData?.school
											)
										) : (
											<input
												type="text"
												placeholder={UserData?.school}
												onChange={e => setFixSchool(e.target.value)}
											/>
										)}
									</td>
									<td>
										{!isFix ? (
											UserData?.grade
										) : (
											<select
												value={fixGrade === null ? 'null' : String(fixGrade)}
												onChange={e => {
													const v = e.target.value
													if (v === 'null') setFixGrade(null)
													else setFixGrade(Number(v))
												}}>
												<option value="null">무학년</option>
												<option value="0">N수</option>
												{(fixSchoolType === '초'
													? [1, 2, 3, 4, 5, 6]
													: fixSchoolType === '중' || fixSchoolType === '고'
														? [1, 2, 3]
														: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
												).map(n => (
													<option key={n} value={String(n)}>
														{n}
													</option>
												))}
											</select>
										)}
									</td>
									<td>
										{!isFix ? (
											UserData?.phone == '' ? (
												'-'
											) : (
												UserData?.phone
											)
										) : (
											<input
												type="text"
												placeholder={UserData?.phone}
												onChange={e => setFixPhone(e.target.value)}
											/>
										)}
									</td>
									<td>
										{!isFix ? (
											UserData?.phone2 == '' ? (
												'-'
											) : (
												UserData?.phone2
											)
										) : (
											<input
												type="text"
												placeholder={UserData?.phone2}
												onChange={e => setFixPhone2(e.target.value)}
											/>
										)}
									</td>
									<td>
										{!isFix ? (
											UserData?.createdAt
										) : (
											<input
												type="date"
												placeholder={UserData?.createdAt}
												onChange={e => setFixCreatedAt(e.target.value)}
											/>
										)}
									</td>
									<td>
										{!isFix ? (
											convertBinaryToDays(UserData?.days)
										) : (
											<Select
												mode="multiple"
												placeholder={convertBinaryToDays(UserData?.days) || '요일 선택'}
												value={fixSelectedDays}
												onChange={vals => setFixSelectedDays(vals as string[])}
												style={{ minWidth: 140 }}
												options={DAY_OPTIONS.map(d => ({ label: d, value: d }))}
											/>
										)}
									</td>
									<td>
										{!isFix ? (
											UserData?.status == 1 ? (
												'Y'
											) : (
												'N'
											)
										) : (
											<select
												style={{ minWidth: '40px' }}
												onChange={e => setFixStatus(e.target.value)}>
												<option value="1">Y</option>
												<option value="0">N</option>
											</select>
										)}
									</td>
								</tr>
							</tbody>
							{/* ===== 모바일 일 때 ===== */}
							<div className="mobile">
								<div>
									<div>
										<p className="th">학교</p>
										<p className="td">
											{!isFix ? (
												UserData?.schoolType == '' ? (
													'-'
												) : (
													UserData?.schoolType
												)
											) : (
												<select
													value={fixSchoolType}
													onChange={e => {
														const next = e.target.value
														setFixSchoolType(next)
														setFixGrade(prev => clampGradeForSchoolType(next, prev))
													}}>
													<option value="">N수</option>
													<option value="고">고</option>
													<option value="중">중</option>
													<option value="초">초</option>
												</select>
											)}
										</p>
									</div>
									<div>
										<p className="th">학년</p>
										<p className="td">
											{!isFix ? (
												UserData?.grade
											) : (
												<select
													value={fixGrade === null ? 'null' : String(fixGrade)}
													onChange={e => {
														const v = e.target.value
														if (v === 'null') setFixGrade(null)
														else setFixGrade(Number(v))
													}}>
													<option value="null">무학년</option>
													<option value="0">N수</option>
													{(fixSchoolType === '초'
														? [1, 2, 3, 4, 5, 6]
														: fixSchoolType === '중' || fixSchoolType === '고'
															? [1, 2, 3]
															: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
													).map(n => (
														<option key={n} value={String(n)}>
															{n}
														</option>
													))}
												</select>
											)}
										</p>
									</div>
								</div>
								<div>
									<div>
										<p className="th">학교명</p>
										<p className="td">
											{!isFix ? (
												UserData?.school
											) : (
												<input
													type="text"
													placeholder={UserData?.school}
													onChange={e => setFixSchool(e.target.value)}
												/>
											)}
										</p>
									</div>
									<div>
										<p className="th">등원요일</p>
										<p className="td">
											{!isFix ? (
												convertBinaryToDays(UserData?.days)
											) : (
												<Select
													mode="multiple"
													placeholder={convertBinaryToDays(UserData?.days) || '요일 선택'}
													value={fixSelectedDays}
													onChange={vals => setFixSelectedDays(vals as string[])}
													style={{ minWidth: 140 }}
													options={DAY_OPTIONS.map(d => ({ label: d, value: d }))}
												/>
											)}
										</p>
									</div>
								</div>
								<div>
									<div>
										<p className="th">수업과정</p>
										<p className="td">{UserData?.classCount}</p>
									</div>
									<div>
										<p className="th">재원여부</p>
										<p className="td">
											{!isFix ? (
												UserData?.status == 1 ? (
													'Y'
												) : (
													'N'
												)
											) : (
												<select
													style={{ minWidth: '40px' }}
													onChange={e => setFixStatus(e.target.value)}>
													<option value="1">Y</option>
													<option value="0">N</option>
												</select>
											)}
										</p>
									</div>
								</div>
								<div>
									<p className="th">등록일</p>
									<p className="td">
										{!isFix ? (
											UserData?.createdAt
										) : (
											<input
												type="date"
												placeholder={UserData?.createdAt}
												onChange={e => setFixCreatedAt(e.target.value)}
											/>
										)}
									</p>
								</div>
								<div>
									<p className="th">학생번호</p>
									<p className="td">
										{!isFix ? (
											UserData?.phone
										) : (
											<input
												type="text"
												placeholder={UserData?.phone}
												onChange={e => setFixPhone(e.target.value)}
											/>
										)}
									</p>
								</div>
								<div>
									<p className="th">학부모번호</p>
									<p className="td">
										{!isFix ? (
											UserData?.phone2
										) : (
											<input
												type="text"
												placeholder={UserData?.phone2}
												onChange={e => setFixPhone2(e.target.value)}
											/>
										)}
									</p>
								</div>
								<div>
									<p className="th">비고</p>
									<p
										className="td"
										style={{
											whiteSpace: 'pre-wrap',
										}}>
										{!isFix ? (
											UserData?.memo
										) : (
											<TextArea
												value={fixMemo}
												style={{ minHeight: 200, height: 300 }}
												onChange={e => setFixMemo(e.target.value)}
											/>
										)}
									</p>
								</div>
							</div>
						</StudentViewTable>
						<div
							style={{
								width: '100%',
								textAlign: 'left',
								flex: 1,
								minHeight: 80,
								padding: 5,
								background: '#efefef',
								border: '1px solid #ccc',
								whiteSpace: 'pre-wrap',
							}}>
							<p style={{ marginBottom: 5, fontWeight: 'bold', fontSize: 12 }}>비고</p>
							{!isFix ? (
								UserData?.memo
							) : (
								<textarea
									defaultValue={UserData?.memo}
									onChange={e => setFixMemo(e.target.value)}
									style={{ width: '100%', flex: 1 }}
								/>
							)}
						</div>
						<LectureViewTable>
							<thead>
								<tr>
									<th>No.</th>
									<th>강의</th>
									<th>학교</th>
									<th>요일</th>
									<th>시간</th>
									<th>강사</th>
									<th>방식</th>
									<th>개강일</th>
									<th>종강일</th>
								</tr>
							</thead>
							<tbody>
								{UserClassData?.map((it, idx) => (
									<tr key={idx}>
										<td>{idx + 1}</td>
										<td className="lecture">
											{it.name}
											{it.type == '관리식' && (
												<button
													className="manageNoteBtn"
													onClick={() => {
														console.log('lecture it', it)
														setSelectLecture(it)
														setManageSt(true)
														setEditNoteIndex({ id: it.id, student: selectStudent })
													}}
													style={{
														border: '1px solid #EFA44F',
														backgroundColor: isWrite.find(
															entry => entry.id === it.id && entry.student === selectStudent
														)?.value
															? '#EFA44F'
															: 'transparent',
														color: isWrite.find(
															entry => entry.id === it.id && entry.student === selectStudent
														)?.value
															? '#FFF'
															: '#EFA44F',
													}}>
													<Icon>
														{isWrite.find(
															entry => entry.id === it.id && entry.student === selectStudent
														)?.value ? (
															<FaCheck />
														) : (
															<BsFillPencilFill />
														)}
													</Icon>
													<p>학습일지</p>
												</button>
											)}
										</td>
										<td>{it.schoolType}</td>
										<td>{convertBinaryToDays(it.days)}</td>
										<td>
											{it.time == '' || it.time == '00:00'
												? '-'
												: it?.time?.slice(3, 5) === '00'
													? it?.time?.slice(0, 2) + '시간'
													: it?.time?.slice(0, 2) + '시간' + it?.time?.slice(3, 5) + '분'}
										</td>
										<td>
											{it.teacherNames?.length == 1 ? it.teacherNames : it.teacherNames.join(', ')}
										</td>
										<td>{it.type}</td>
										<td>{it?.startedAt?.slice(0, 10)}</td>
										<td>{it?.endedAt?.slice(0, 10) == '' ? '-' : it?.endedAt?.slice(0, 10)}</td>
									</tr>
								))}
							</tbody>
						</LectureViewTable>
						{isAdd ? (
							<IsAdd>
								<div className="AddHeader">
									<LectureListSearch style={{ width: '100%' }}>
										<input
											type="text"
											placeholder="강의검색"
											value={searchKeyword}
											onChange={e => setSearchKeyword(e.target.value)}
										/>
										<Icon style={{ color: '#DDAFAF', scale: '1.5' }}>
											<CiSearch />
										</Icon>
									</LectureListSearch>
									<div className="btns">
										<button className="add" onClick={clickAddStudent}>
											추가
										</button>
										<button className="cancel" onClick={() => setIsAdd(false)}>
											취소
										</button>
									</div>
								</div>
								<div className="AddTable">
									<LectureViewTable>
										<thead>
											<tr>
												<th>강의명</th>
												<th>대상</th>
												<th>요일</th>
												<th>방식</th>
												<th>강사</th>
											</tr>
										</thead>
										<tbody>
											{searchAddLecture()?.map((it, idx) => (
												<tr
													className="student"
													key={idx}
													onClick={() => setAddLecture(it.id)}
													style={{
														backgroundColor:
															AddLecture == it.id ? 'rgba(247, 139, 133, 0.5)' : 'transparent',
													}}>
													<td>{it.name}</td>
													<td>{it.schoolType}</td>
													<td>{convertBinaryToDays(it.days)}</td>
													<td>{it.type}</td>
													<td>
														{it.teacherNames?.length == 1
															? it.teacherNames
															: it.teacherNames.join(', ')}
													</td>
												</tr>
											))}
										</tbody>
									</LectureViewTable>
								</div>
							</IsAdd>
						) : (
							<IsAddBtn onClick={() => setIsAdd(true)}>
								<FaPlus />
								<p>추가</p>
							</IsAddBtn>
						)}
					</div>
				)}
			</LectureView>
			{isAddStudent && <AddStudentModal setIsAddStudent={setIsAddStudent} />}
		</LectureWrapper>
	)
}

export default React.memo(Student)
